const prefix = 'admin-users'

export const AdminUserQueryKeys = {
  Users: `${prefix}/users`,
  Roles: `${prefix}/roles`,
} as const
